<template>
  <div class="od-container" :class="{'px-0': isMobile}" id="instrument">
    <section class="equ_movie">
      <div class="fmovie">
          <youtube :video-id="'78TYLod1e9s'" :player-vars="playerVars" ref="youtube" width="100%"/>
      </div>
    </section>

    <section class="equ_list">
      <ul>
        <li v-for="(item, idx) in list" :key="`gear-${idx}`" :class="[`equ${(idx+1).toString().padStart(2, '0')}`]">
          <div class="inwrap">
            <dl class="tbox">
              <dt>{{item.title}}</dt>
              <dd v-if="isMobile" v-html="item.desc2.replace(/(?:\r\n|\r|\n)/g, '<br />')" />
              <dd v-else v-html="item.desc1.replace(/(?:\r\n|\r|\n)/g, '<br />')" />
            </dl>
            <img v-if="isMobile" v-lazy="`${publicPath}img/intro/m_sub_system_${(idx+1).toString().padStart(2, '0')}.png`" />
            <div v-else class="img"></div>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'IntroGear',
  data() {
    return {
      playerVars: {
        autoplay: 1,
        loop: 1,
        rel: 0,
        controls: 0,
        showinfo: 0,
        playlist: '78TYLod1e9s',
      },
      list: [
        {
          title: 'UV 액티베이터',
          desc1: 'UV광조사를 통해 20초만에 노화된 임플란트의 SLA표면을\n안티에이징시켜 친수성을 극대화 시켜주는 장비',
          desc2: 'UV광조사를 통해 20초만에\n노화된 임플란트의 SLA표면을 안티에이징시켜\n친수성을 극대화 시켜주는 장비',
        },
        {
          title: '프라임 스캔',
          desc1: '독일 시로나사의 최신 3D 구강 스캐너로 치아와 잇몸을 정확하고 선명하게\n촬영, 디지털 영상정보로 전환하는 장비',
          desc2: '독일 시로나사의 최신 3D 구강 스캐너로\n치아와 잇몸을 정확하고 선명하게\n촬영, 디지털 영상정보로 전환하는 장비',
        },
        {
          title: 'Orthophos SL 3D CT',
          desc1: 'DCS센서를 사용해 한번의 촬영으로 치조골 및 상악동의\n정확한 3D 이미지를 획득하는 전산화단층촬영장치',
          desc2: 'DCS센서를 사용해 한번의 촬영으로 치조골 및 상악동의\n정확한 3D 이미지를 획득하는 전산화단층촬영장치',
        },
        {
          title: '자가치아뼈 가공장비',
          desc1: '발치한 치아를 활용하여 뼈이식 임플란트에 사용할 수 있게\n자가치아뼈를 만드는 초음파진공시스템(VacuaSonic)',
          desc2: '발치한 치아를 활용하여\n뼈이식 임플란트에 사용할 수 있게\n자가치아뼈를 만드는 초음파진공시스템(VacuaSonic)',
        },
        {
          title: '자가혈 원심분리기',
          desc1: '혈액으로부터 백혈구와 혈소판 및 성장인자를 추출하여\n농축(PRF)하는 원심분리 장비',
          desc2: '혈액으로부터 백혈구와 혈소판 및 성장인자를\n추출하여 농축(PRF)하는 원심분리 장비',
        },
        {
          title: '세렉 MCXL',
          desc1: '치아용 세라믹 전용 절삭 가공 장비로\n오늘하루 완성 보철물 제작에 최적화된 장비',
          desc2: '치아용 세라믹 전용 절삭 가공 장비로\n오늘하루 완성 보철물 제작에 최적화된 장비',
        },
        {
          title: '5축 밀링 머신',
          desc1: '치과용 회전 절삭가공 장비로 디지털 지르코니아 보철물 제작에 사용',
          desc2: '치과용 회전 절삭가공 장비로\n디지털 지르코니아 보철물 제작에 사용',
        },
        {
          title: '3D 모델스캐너',
          desc1: '초고해상도로 석고 모형을 스캔하여 정밀한 보철물 제작을 돕는\n광학 디지털 스캐너 장비',
          desc2: '초고해상도로 석고 모형을 스캔하여\n정밀한 보철물 제작을 돕는 광학 디지털 스캐너 장비',
        },
        {
          title: '무통마취기',
          desc1: '마취속도 및 주사량을 컴퓨터를 통해 제어하여,\n통증을 획기적으로 감소시켜주는 마취장비',
          desc2: '마취속도 및 주사량을 컴퓨터를 통해 제어하여,\n통증을 획기적으로 감소시켜주는 마취장비',
        },
        {
          title: '오스템 미백기',
          desc1: '에너지밀도가 440mW/cm²로 타 제품에 비해 2배 이상 높은 고에너지로\n치아미백의 활성도를 극대화 시켜주는 미백기',
          desc2: '에너지밀도가 440mW/cm²로\n타 제품에 비해 2배 이상 높은고에너지로\n치아미백의 활성도를 극대화 시켜주는 미백기',
        },
        {
          title: '플라즈마 소독기',
          desc1: '임플란트 기구 소독을 위한 멸균력이 가장 높은 저온 소독기',
          desc2: '임플란트 기구 소독을 위한\n멸균력이 가장 높은 저온 소독기',
        },
        {
          title: '오스템 유니트체어 K3',
          desc1: '인체공학적 디자인을 통해 환자분께 최적의 편안함을 제공하는 유니트 체어',
          desc2: '인체공학적 디자인을 통해\n환자분께 최적의 편안함을 제공하는 유니트 체어',
        },
      ],
    };
  },
  mounted() {
    this.$refs.youtube.player.playVideo();
  },
};
</script>

<style scoped>

</style>
